interface UsualConditionsAvailablePaymentMethodParams {
    readonly conditionsDescription: string;
    readonly instrumentDescription: string;
}
/**
 * Represents the usual payment conditions agreed with Europastry that are available to the user.
 */
export class UsualConditionsDTO {

    readonly conditionsDescription: string;
    readonly instrumentDescription: string;

    constructor(params: UsualConditionsAvailablePaymentMethodParams) {
        this.conditionsDescription = params.conditionsDescription;
        this.instrumentDescription = params.instrumentDescription;
    }

}